/* eslint-disable import/named */
import React from "react";
import { bool, func, number, shape } from "prop-types";
import { useDispatch } from "react-redux";
import { routerActions } from "connected-react-router";
import GridTable from "pages/_components/GridTable/GridTable";
import CustomText from "pages/_components/CustomText/CustomText";
import FormattedDate from "pages/_components/FormattedDate";
import { echeqPropTypes } from "pages/echeck/echeckPropTypes";
import { stateActive, stateActivePendient, statusTagColor } from "util/cedip";

import FormattedAmount from "pages/_components/FormattedAmount";
import CustomButton from "pages/_components/CustomButton/CustomButton";
import InfoTag from "pages/echeck/components/InfoTag";
import CustomData from "pages/_components/CustomData/CustomData";
import SideBarCedipForm from "../../CedipActions/components/SideBarCedipForm";
import handleClickAcceptAction from "../../ManagementCedip/hooks/handleClickAcceptAction";
import { isCedipTransmitted } from "../../../utils";

const GridCedipItem = ({ receivedCedip, isDesktop, setActionDrawer, positionTab }) => {
    const dispatch = useDispatch();

    const handleClickCancel = () => {
        setActionDrawer({
            showDrawer: false,
            contentDrawer: null,
        });
    };

    const handleClickActionOption = (idAccion) => {
        setActionDrawer({
            showDrawer: true,
            contentDrawer: (
                <SideBarCedipForm
                    idAccion={idAccion}
                    handleCancel={handleClickCancel}
                    handleAccept={() => handleClickAcceptAction(idAccion, receivedCedip, dispatch)}
                />
            ),
        });
    };

    const optionsByState = (state) => {
        const options = [];

        switch (state) {
            case stateActivePendient:
                if (positionTab === 1 && !isCedipTransmitted(receivedCedip)) {
                    options.push(
                        {
                            text: "cedip.item.option4",
                            func: () => {
                                dispatch(routerActions.push(`/depositsCedip/admit/${receivedCedip.cedipId}`));
                            },
                            // func: () => handleClickActionOption("transmit.admit"),
                            textType: "I18N",
                        },
                        {
                            text: "cedip.item.option5",
                            func: () => handleClickActionOption("transmit.repudiate"),
                            textType: "I18N",
                        },
                    );
                }
                if (positionTab === 2) {
                    options.push({
                        text: "cedip.item.option3",
                        func: () => handleClickActionOption("transmit.anulate"),
                        textType: "I18N",
                    });
                }
                break;
            case stateActive:
                options.push({
                    text: "cedip.item.option1",
                    func: () => {
                        dispatch(routerActions.push(`/depositsCedip/transmit/${receivedCedip.cedipId}`));
                    },
                    textType: "I18N",
                });
                break;
            default:
        }
        options.push({
            text: "cedip.item.option2",
            func: () => {
                dispatch(routerActions.push(`/depositsCedip/${receivedCedip.cedipId}`));
            },
            textType: "I18N",
        });
        return options;
    };

    return (
        <>
            <GridTable.Data
                className="align-items-center"
                columnStart={isDesktop ? 1 : 1}
                rowStart={isDesktop ? 1 : 1}
                alignX={isDesktop ? "center" : "flex-start"}>
                {isDesktop ? (
                    <CustomText text={receivedCedip.numeroCertificado} textType="TEXT" />
                ) : (
                    <CustomData
                        titleText="cedip.mycedip.table.title1"
                        titleTextType="I18N"
                        valueText={receivedCedip.numeroCertificado}
                        valueTextType="TEXT"
                    />
                )}
            </GridTable.Data>
            <GridTable.Data
                className="align-items-center"
                columnStart={isDesktop ? 2 : 1}
                rowStart={isDesktop ? 1 : 2}
                alignX={isDesktop ? "center" : "flex-start"}>
                {isDesktop ? (
                    <FormattedDate date={receivedCedip.fechaEmision} dateFormat="DD/MM/YYYY" />
                ) : (
                    <CustomData
                        titleText="cedip.mycedip.table.title2"
                        titleTextType="I18N"
                        valueText={receivedCedip.fechaEmision}
                        valueTextType="DATE"
                    />
                )}
            </GridTable.Data>
            <GridTable.Data
                className="align-items-center"
                columnStart={isDesktop ? 3 : 1}
                rowStart={isDesktop ? 1 : 3}
                alignX={isDesktop ? "center" : "start"}>
                {isDesktop ? (
                    <FormattedDate date={receivedCedip.fechaVencimiento} />
                ) : (
                    <CustomData
                        titleText="cedip.mycedip.table.title3"
                        titleTextType="I18N"
                        valueText={receivedCedip.fechaVencimiento}
                        valueTextType="DATE"
                    />
                )}
            </GridTable.Data>
            <GridTable.Data
                className="align-items-center"
                columnStart={isDesktop ? 4 : 1}
                rowStart={isDesktop ? 1 : 4}
                alignX={isDesktop ? "center" : "start"}>
                {isDesktop ? (
                    <CustomText text={receivedCedip.tna} textType="PERCENTAGE" />
                ) : (
                    <CustomData
                        titleText="cedip.mycedip.table.title4"
                        titleTextType="I18N"
                        valueText={receivedCedip.tna}
                        valueTextType="PERCENTAGE"
                    />
                )}
            </GridTable.Data>
            <GridTable.Data
                className="align-items-center"
                columnStart={isDesktop ? 5 : 1}
                rowStart={isDesktop ? 1 : 5}
                alignX={isDesktop ? "center" : "start"}>
                {isDesktop ? (
                    <FormattedAmount currency={receivedCedip.tipoMoneda} quantity={receivedCedip.montoDepositado} />
                ) : (
                    <CustomData
                        titleText="cedip.mycedip.table.title5"
                        titleTextType="I18N"
                        valueText={
                            <FormattedAmount
                                currency={receivedCedip.tipoMoneda}
                                quantity={receivedCedip.montoDepositado}
                            />
                        }
                        valueTextType="TEXT"
                    />
                )}
            </GridTable.Data>
            <GridTable.Data
                className="tags-wrapper align-items-center"
                columnStart={isDesktop ? 6 : 2}
                rowStart={1}
                alignX={isDesktop ? "center" : "end"}>
                <InfoTag
                    type="info"
                    message={receivedCedip.estado}
                    tagBackground={statusTagColor(receivedCedip.estado)}
                />
            </GridTable.Data>
            <GridTable.Data columnStart={isDesktop ? 7 : 3} rowStart={1} rowWidth={1} alignX="end">
                {optionsByState(receivedCedip.estado).length > 0 && (
                    <CustomButton
                        pullRight
                        icon="images/figma/icon/menu-mobile.svg"
                        options={optionsByState(receivedCedip.estado)}
                    />
                )}
            </GridTable.Data>
        </>
    );
};

GridCedipItem.propTypes = {
    receivedCedip: shape(echeqPropTypes).isRequired,
    isDesktop: bool.isRequired,
    setActionDrawer: func.isRequired,
    positionTab: number.isRequired,
};

export default GridCedipItem;
